import { render, staticRenderFns } from "./media-dialog.vue?vue&type=template&id=597f8f5e&scoped=true&"
import script from "./media-dialog.vue?vue&type=script&lang=js&"
export * from "./media-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597f8f5e",
  null
  
)

export default component.exports